import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogBySystemComponent } from './blog-by-system.component';
import { HelpCardSlideModule } from '@app/wiki/help/components/help-card-slide/help-card-slide.module';
import { CoreModule } from '@angular/flex-layout';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';
import { EmptyComponentModule } from '../empty-component/empty-component.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [BlogBySystemComponent],
    exports: [BlogBySystemComponent],
    imports: [CommonModule, CoreModule, InfoBlockModule, HelpCardSlideModule, EmptyComponentModule, TranslateModule]
})
export class BlogBySystemModule {}
